import React from 'react';

import EyeOpen from './eye-open.svg';
import EyeCrossed from './eye-crossed.svg';
import CloseIcon from 'Static/icons/close-x.svg';
import LoadingAnimation from 'Components/LoadingAnimation';
import styles from './InputAction.scss';

const InputAction = ({ type, label, clickHandler }) => {
  const actionIcon = type => {
    switch (type) {
      case 'hidePassword':
        return <EyeCrossed className="InputAction__icon" />;
      case 'showPassword':
        return <EyeOpen className="InputAction__icon" />;
      case 'clear':
        return <CloseIcon className="InputAction__icon" />;
      case 'loading':
        return (
          <div className="InputAction__icon">
            <LoadingAnimation type="tiny" />
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div
      className={`InputAction InputAction--${type}`}
      onClick={() => clickHandler()}
    >
      {label ? <div className="InputAction__label">{label}</div> : null}
      {actionIcon(type)}
    </div>
  );
};

export default InputAction;
